export default "__VITE_ASSET__$2bUX8eF__"